<template>
  <div>
    <div class=" mainLoader" v-if="loading">
      <!-- <img src="../assets/images/load.gif" width="100px"> -->
    </div>
    <div class="realbody">
      <div class="top_summary">
        <div class="container">
          <div class="row">
            <div class="col-md-6" style="padding: 70px 0px;">
              <p class="top_summary_header mplus2p-m spacing4 noiseblack">{{$t('cp_title')}}</p>
              <p class="top_summary_comment mplus2p-r spacing1-2 noiseblack">{{$t('cp_desc')}}</p>
            </div>
            <div class="col-md-6" style="text-align: center;">
              <img src="../../assets/imgs/companyprofile.png" class="pman" />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" style="margin-top: 40px;">
          <div class="col-md-3">
            <app-side-bar :selectedItem="selectedItem"></app-side-bar>
            <!-- <app-c-company-sidenav :selectedItem="selectedItem"></app-c-company-sidenav> -->
          </div>
          <div class="col-md-9">
            <div class="page_title">
              <span class="page_title_comment mplus2p-m spacing1-2 noiseblack">{{$t('cr_title')}}</span>
            </div>

            <div class="row pview">
              <form style=" display: contents;" @submit.prevent="doRecuritAdd">
                <div class="col-md-12 pheaderpanel">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack" style="margin-top: 17.5px; margin-bottom: 0px;">
                    {{$t('cr_desc')}}</p>
                  <div style="height: 20px;">
                    <hr style="border-width: 2px; border-color: #3d7dd8; width: 20%; float: left;" />
                    <hr style="border-width: 2px; border-color: #f8fafa; width: 80%; float: left;" />
                  </div>
                </div>

                <!-- subject -->
                <div class="col-md-12 input form-group" :class="{ invalid: $v.title.$error }">
                  <div class="pfpanel">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('cr_sub')}} <span style="color: red;">*</span></label>
                    <span style="float: right; margin-top: 22px;" class="futhergraytxt mplus2p-m spacing1-2 noiseblack"></span>
                  </div>
                  <input class="peditboxes peditinput blog1 form-control" 
                        name="title" 
                        v-model="title" 
                        autofocus 
                        :placeholder="$t('unify_test')">
                  <div v-if="!$v.title.req && titleFocus" class="help-block">{{$t('required_filed')}}</div>
                </div>

                <!-- content -->
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-12 input form-group" :class="{ invalid: $v.content.$error }">
                  <div class="pfpanel">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('cr_content')}} <span style="color: red;">*</span></label>
                    <span style="float: right; margin-top: 22px;" class="futhergraytxt mplus2p-m spacing1-2 noiseblack"></span>
                  </div>
                  <textarea class="peditboxes pedittextarea form-control" 
                            name="content" 
                            v-model="content" 
                            autofocus
                            :placeholder="$t('unify_test')">

                  </textarea>
                  <div v-if="!$v.content.req && contentFocus" class="help-block">{{$t('required_filed')}}</div>
                </div>

                 <!-- why the company hire engineer -->
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-12 form-group">
                  <div class="pfpanel">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('company_hire_engineer')}}</label>
                  </div>
                  <div class="selectdiv peselectboxs form-group w-100">

                    <select class="form-control" 
                            name="listed" 
                            v-model="sel_company_hire_engineer" 
                            autofocus>
                      <option v-if="sel_company_hire_engineer == ''" class="mplus2p-r black" style="font-size: 0.875rem;" value=""> {{$t('r_select')}}
                      </option>
                      <option v-for="(i, index) of company_hire_engineer" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :value="i.id">{{lan == 'en' ? i.en_reason : i.jp_reason}}
                      </option>
                    </select>
                  </div>
                </div>

               
                <!-- recuirtment tension -->
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-12 input form-group" :class="{ invalid: $v.sel_recruitment_tension.$error }">
                  <div class="pfpanel">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('recruitment_tension')}} <span style="color: red;">*</span></label>
                  </div>
                  <div class="selectdiv peselectboxs form-group w-100">
                    <select class="form-control" 
                            name="listed" 
                            v-model="sel_recruitment_tension" 
                            autofocus>
                      <option v-if="sel_recruitment_tension == ''" class="mplus2p-r black" style="font-size: 0.875rem;" value=""> {{$t('r_select')}}
                      </option>
                      <option v-for="(i, index) of recruitment_tension" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :selected="sel_recruitment_tension.id" :value="i.id">
                        {{lan == 'en' ? i.en_tension : i.jp_tension}}
                      </option>
                    </select>
                    <div v-if="!$v.sel_recruitment_tension.req && tensionFocus" style="margin-left:0px" class="help-block">{{$t('required_filed')}}</div>
                  </div>
                </div>

                <!-- full time / part time -->
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-12 errorClass form-group" :class="{ invalid: $v.sel_schedule.$error }">
                  <div class="pfpanel">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('job_type')}} <span style="color: red;">*</span></label>
                  </div>
                  <div class="form-group w-100" >
                    <ul class="list-unstyled mb-0 peselectboxs form-control listError custom-wrapper" id="rtoc-block">
                      <li v-for="(rtoc,index) of schedule" :key="index">
                        <label :for="'rtoc'+rtoc.id" class="custom-control material-checkbox">
                          <input type="checkbox" class="material-control-input" v-model="sel_schedule"
                                 :id="'rtoc'+rtoc.id" :value="rtoc.id">
                          <span class="material-control-indicator"></span>
                          <span class="material-control-description">{{lan == 'en'?rtoc.en_type:rtoc.jp_type}}</span>
                        </label>
                      </li>
                    </ul>
                     <div v-if="!$v.sel_schedule.req && scheduleFocus" style="margin-left:20px" class="help-block">{{$t('required_filed')}}</div>
                  </div>
                </div>

                  <!-- Supplement of full time/ part time -->
                <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-12 form-group">
                    <div class="pfpanel">
                      <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('cr_supplement_fulltime_parttime')}}</label>
                    </div>
                    <textarea :placeholder="$t('unify_test')" class="peditboxes pedittextarea form-control" name="any_request" v-model="supplement_time" autofocus style="margin-top: 10px;" >
                    </textarea>
                  </div>


                  <!-- payment -->
                 <div class="col-md-12">
                   <div class="input payment" :class="{ invalid: employmentFormFocus || timeUnitFocus || lowerLimitFocus || upperLimitFocus}">
                      <label class="peditlabel mplus2p-m spacing1-2 ">{{$t('payment_text')}} </label>
                   </div>
                   <div class="row ml-2" >
                      <div class="col-md-3 input" :class="{ invalid: employmentFormFocus }">
                          <label  class="top_summary_comment mplus2p-m  spacing1-2 noiseblack">{{$t('payment_employment_form')}}</label>
                        </div>
                        <div class="col-md-2 input">
                          <label class="top_summary_comment mplus2p-m  spacing1-2 noiseblack"></label>
                        </div>
                        <div  class="col-md-3 input" :class="{ invalid: lowerLimitFocus }">
                          <label class="top_summary_comment mplus2p-m  spacing1-2 noiseblack">{{$t('payment_lower_limit')}}</label>
                        </div>
                        <div  class="col-md-3 input">
                          <label class="top_summary_comment mplus2p-m spacing1-2 noiseblack">{{$t('payment_upper_limit')}}</label>
                        </div>
                    </div>
                    <div  class="textGray mb-2"  v-for="(item, index) in payments" :key="index">
                       <div class="row ml-2">
                         <div class="col-md-3">
                          <div class="input" :class="{ invalid: item.employmentFormFocus }">
                            <div class="selectdiv dynamicSelect form-group">
                              <select  @change="employmentForm(index)" class="form-control mb-3 " name="location" v-model="item.sel_employment_form" autofocus>
                                <option v-if="item.sel_employment_form == ''" class="mplus2p-r black" style="font-size: 0.875rem;" :value="''">{{$t('r_select')}}</option>
                                <option v-for="(i,index) of schedule" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :value="i.id">{{lan == "en" ? i.en_type : i.jp_type}}
                                </option>
                              </select>
                            </div>
                          </div>
                         </div>
                         <div class="col-md-2">
                           <div class="input" :class="{ invalid: item.timeUnitFocus }">
                            <div  class="selectdiv  form-group" >
                              <select @change="timeUnit(index)" class="form-control" name="experience" v-model="item.sel_time_unit" autofocus>
                                <option  v-if="item.sel_time_unit == ''" class="mplus2p-r black" style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                                <option v-for="(i,index) of desiar_engineer" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :value="i.id">{{lan == 'en' ? i.en_type : i.jp_type}}
                                </option>
                              </select>
                            </div>
                           </div>
                         </div>
                         <div class="col-md-3">
                           <div class="row">
                             <div class="col-md-9">
                               <div class="input" :class="{ invalid:  item.lowerLimitFocus }">
                                <div class="form-group">
                                  <vue-numeric @input="lowerLimit(index)" ref="numaric_income"  class="peditboxes numaric form-control" id="numaric_income"  separator="," v-model="item.sel_lower_limit" style="height: 50px;margin-top: 5px;"></vue-numeric>
                                </div>
                               </div>
                             </div>
                             <div class="col-md-3 mt-3 yen">
                               <div class="input yen-child" :class="{ 'error-block' : item.lowerLimitFocus }">{{$t('yen')}}~
                               </div>
                             </div>
                           </div>
                         </div>
                         <div class="col-md-3">
                            <div class="row">
                             <div class="col-md-9">
                               <div class="input" :class="{ invalid: item.upperLimitFocus }">
                                <div class="form-group">
                                  <vue-numeric @input="upperLimit(index)" ref="numaric_income"  class="peditboxes numaric form-control" id="numaric_income"  separator="," v-model="item.sel_upper_limit" style="height: 50px;margin-top: 5px;"></vue-numeric>
                                </div> 
                               </div>
                             </div>
                             <div class="col-md-3 mt-3">
                              <div class="input" :class="{ 'error-block' : item.upperLimitFocus }">
                                {{$t('yen')}}
                              </div>
                             </div>
                            </div>
                         </div>
                         <div class="col-md-1">
                           <button v-if="index !=  payments.length - 1" type="button" class="btn btn-danger clickcbtn"  @click.prevent="onDeleteHobby(index,item.id)" style="float: right;">
                              <i class="fa fa-trash "></i>
                            </button>
                             <button v-if="index ==  payments.length - 1" type="button" :disabled='payments.length == 5' class="btn whitebtn clickcbtn"  @click.prevent="onAddJobDetail()" style="float: right;">
                              <i class="fa fa-plus "></i>
                            </button>
                         </div>
                       </div>
                  </div>
                       <div  v-if="(timeUnitFocus || employmentFormFocus || lowerLimitFocus || upperLimitFocus)" style="margin-left:20px; margin-top:-18px" class="error-block">{{$t('ep_past_job_details_error2')}}</div>
                 </div>

                 <!-- location -->
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-12 input form-group" :class="{ invalid: $v.location.$error }">
                  <div class="pfpanel">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('cr_work_location')}} <span style="color: red;">*</span></label>
                  </div>
                  <input class="peditboxes peditinput blog1 form-control" 
                         name="location" 
                         v-model="location" 
                         autofocus
                         :placeholder="$t('unify_test')">
                  <div v-if="!$v.location.req && locationFocus" class="help-block">{{$t('required_filed')}}</div>
                </div>

                <!-- contract type -->
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-12 errorClass form-group" :class="{ invalid: $v.sel_type_of_contract.$error }">
                  <div class="pfpanel">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('contract')}} <span style="color: red;">*</span></label>
                  </div>
                
                  <div class="form-group  w-100" >
                    <ul class="list-unstyled mb-0 peselectboxs form-control listError custom-wrapper" id="wantedjob">
                      <li v-for="(rtow,index) of type_of_contract" :key="index">
                        <label :for="'rtow'+index" class="custom-control material-checkbox">
                          <input type="checkbox" class="material-control-input"  v-model="sel_type_of_contract"
                                 :id="'rtow'+index" :value="rtow.id">
                          <span class="material-control-indicator input"></span>
                          <span class="material-control-description">{{lan == 'en'?rtow.en_type:rtow.jp_type}}</span>
                        </label>
                      </li>
                    </ul>
                     <div v-if="!$v.sel_type_of_contract.req && contractFocus" style="margin-left:20px" class="help-block">{{$t('required_filed')}}</div>
                  </div>
                </div>


                <!-- Supplement of type of contract -->
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-12 form-group">
                  <div class="pfpanel">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('cr_supplement_contract')}}</label>
                  </div>
                  <textarea :placeholder="$t('unify_test')" class="peditboxes pedittextarea form-control" name="any_request" v-model="supplement_contract" autofocus style="margin-top: 10px;" >
                  </textarea>
                </div>

                <!-- required technical skill text -->
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-12 input form-group" :class="{ invalid: $v.requiredTechniqueSkill.$error }">
                  <div class="pfpanel">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('required_technique_skill')}} <span style="color: red;">*</span></label>
                  </div>
                  <textarea :placeholder="$t('unify_test')" 
                            class="peditboxes pedittextarea form-control" 
                            name="blog" 
                            v-model="requiredTechniqueSkill" 
                            autofocus 
                            style="margin-top: 10px;" >
                  </textarea>
                  <div v-if="!$v.requiredTechniqueSkill.req && skillFocus" class="help-block">{{$t('required_filed')}}</div>
                </div>

                <!-- better technique skill if there is text -->
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-12 form-group">
                  <div class="pfpanel">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('better_technique_skill_if_there_is')}}</label>
                  </div>
                  <textarea :placeholder="$t('unify_test')" class="peditboxes pedittextarea form-control" name="blog" v-model="betterTechniqueSkillIfThereIs" autofocus style="margin-top: 10px;" >
                  </textarea>
                </div>

                <!-- required personality -->
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-12 form-group">
                  <div class="pfpanel">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('required_personality')}}</label>
                  </div>
                  <textarea :placeholder="$t('unify_test')" class="peditboxes pedittextarea form-control" name="any_request" v-model="requiredPersonality" autofocus style="margin-top: 10px;" >
                  </textarea>
                </div>

                <!-- any request -->
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-12 form-group">
                  <div class="pfpanel">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('any_request')}}</label>
                  </div>
                  <textarea :placeholder="$t('unify_test')" class="peditboxes pedittextarea form-control" name="any_request" v-model="anyRequest" autofocus style="margin-top: 10px;" >
                  </textarea>
                </div>

                <!-- skill keyword -->
                 <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-12 input form-group"  :class="{ invalid: $v.selectedSkill.$error  && selectedSkillFocus}" >
                    <div class="pfpanel">
                        <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('cr_skill_keyword')}} <span style="color: red;">*</span></label>
                    </div>
                    <div class="peselectboxs form-group  w-100"  >
                        <div  v-for="(option, index) in skillEngineer" :key="index" class="input-group">
                          <multiselect v-model="selectedSkill" class="errorClass" :class="{ invalid: $v.selectedSkill.$error  && selectedSkillFocus}"  :label="lan=='en' ? 'en_name' : 'jp_name'" track-by="code" :placeholder="$t('c_search_keyword')" open-direction="bottom" :options="option.skilldropdown" :multiple="true" :clear-on-select="true" :close-on-select="false" :options-limit="300"   :max-height="600" :show-no-results="false" :hide-selected="true">
                            <template slot="tag" slot-scope="props">
                              <div class="option__desc skillTag">
                                <span class="option__title">{{ lan=='en' ? props.option.en_name : props.option.jp_name }}</span>
                                <span class="custom__remove" @click="props.remove(props.option)">
                                  <i style="right: 6px; position: absolute; cursor:pointer" class="fa fa-times" aria-hidden="true"></i>
                                </span>
                              </div>
                            </template>
                            <template slot="option" slot-scope="props">
                              <div class="option__desc">
                                <span class="option__title">{{ lan=='en' ? props.option.en_name : props.option.jp_name }}</span>
                              </div>
                            </template>
                            <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
                          </multiselect>
                      </div>
                    </div>
                     <div v-if="!$v.selectedSkill.req && selectedSkillFocus" style="margin-left:20px" class="help-block">{{$t('required_filed')}}</div>
                </div>

                <!--Benefits for engineers -->
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-12 form-group">
                  <div class="pfpanel">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('cr_bebefit_engineer')}}</label>
                  </div>
                  <textarea :placeholder="$t('unify_test')" class="peditboxes pedittextarea form-control" name="any_request" v-model="en_benefits" autofocus style="margin-top: 10px;" >
                  </textarea>
                </div>

                <!-- The role of this recruit -->
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-12 form-group">
                  <div class="pfpanel">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('cr_recruit_role')}}</label>
                  </div>
                  <textarea :placeholder="$t('unify_test')" class="peditboxes pedittextarea form-control" name="any_request" v-model="recruit_role" autofocus style="margin-top: 10px;" >
                  </textarea>
                </div>

                <!-- How to proceed with project / development -->
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-12 form-group">
                  <div class="pfpanel">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('cr_process_project')}}</label>
                  </div>
                  <textarea :placeholder="$t('unify_test')" class="peditboxes pedittextarea form-control" name="any_request" v-model="how_to_proceed" autofocus style="margin-top: 10px;" >
                  </textarea>
                </div>

                <!-- Current structure -->
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-12 form-group">
                  <div class="pfpanel">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('cr_current_structure')}}</label>
                  </div>
                  <textarea :placeholder="$t('unify_test')" class="peditboxes pedittextarea form-control" name="any_request" v-model="current_structure" autofocus style="margin-top: 10px;" >
                  </textarea>
                </div>

                <!-- Technique Stack -->
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-12 form-group">
                  <div class="pfpanel">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('cp_technique_stack')}}</label>
                  </div>
                  <textarea :placeholder="$t('unify_test')" class="peditboxes pedittextarea form-control" name="any_request" v-model="technique_stack" autofocus style="margin-top: 10px;" >
                  </textarea>
                </div>

               

                <div class="col-md-12" style="height: 75px;"></div>
                <div class="col-md-12 pv_btnpanel">
                  <button type="submit"  class="btn bluebtn updatebtn">{{$t('cr_button')}}</button>
                </div>
              </form>
            </div>
            <div class="modal fade" id="companyProfileImage" role="dialog">
              <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" style="color: #3d7dd8;">&times;</button>
                  </div>
                  <div class="modal-body" style="text-align: center;">
                    <div style="width: 400px; height:150px; border: 1px solid gray; display: inline-block;">
                      <vue-cropper ref='cropper' 
                            :guides="true" 
                            :view-mode="2" 
                            drag-mode="crop" 
                            :auto-crop-area="1" 
                            :min-container-width="400" 
                            :min-container-height="150" 
                            :background="true" 
                            :zoomable="false"
                            :zoomOnTouch="false"
                            :zoomOnWheel="false"
                            :cropBoxResizable="false"
                            :rotatable="false" :src="imgSrc" alt="Source Image" :img-style="{ 'width': '100%', 'height': 'auto' }">
                      </vue-cropper>
                    </div>
                    <div >
                      <img class="company" style="width: auto; height: 150px; margin-top:30px border: 1px solid gray" alt="Cropped Image" v-if="cropImg" :src="cropImg" />
                      <img class="company" style="width: auto; height: 150px; margin-top:30px" alt="Cropped Image" v-if="!cropImg" src="../../assets/imgs/default-bigcover.jpg" />
                    </div>
                    <br/>
                    <br/>

                    <button @click="cropImage">{{$t('cp_image_crop')}}</button>
                  </div>
                  <div class="modal-footer">
                    <button class='btn bluebtn DoneCrop' data-dismiss="modal">{{$t('cp_done')}}</button>
                  </div>
                </div>

              </div>
            </div>
            <button type="button" class="d-none" data-toggle="modal"  data-backdrop="static" data-keyboard="false" data-target="#companyProfileImage" ref="myBtnCompanyEdit">
              Launch demo modal
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import NavSidebar from "./company_sidebar";
import axios from "axios";
import { EventBus } from "../../main.js";
import VueNumeric from 'vue-numeric'
export default {
  mixins: [validationMixin],

    validations: {
      title: {req: required},
      content: {req: required},
      location: {req: required},
      sel_recruitment_tension: {req: required},
      requiredTechniqueSkill: {req: required},
      sel_schedule: {req: required},
      sel_type_of_contract: {req: required},
      selectedSkill: {req: required},
  },
  data() {
    return {
      titleFocus: false,
      contentFocus: false,
      locationFocus: false,
      tensionFocus: false,
      skillFocus: false,
      scheduleFocus: false,
      contractFocus: false,
      selectedSkillFocus: false,
      employmentFormFocus: false,
      timeUnitFocus: false,
      lowerLimitFocus: false,
      upperLimitFocus: false,

      selectedItem: 22,
      title: "",
      content: "",
      supplement_time: "",
      supplement_contract: "",
      en_benefits: "",
      recruit_role: "",
      how_to_proceed: "",
      current_structure: "",
      loading: false,
      lan: "jp",

      payments: [{
        sel_employment_form: '',
        sel_time_unit: '',
        sel_lower_limit: '',
        sel_upper_limit: '',
        employmentFormFocus: false,
        timeUnitFocus: false,
        lowerLimitFocus: false,
        upperLimitFocus: false,
      }],

      sel_desiar_engineer: '',
      desiar_engineer: [],

      cropImg: "",
      imgSrc: "",
      img: [],
      image: "",
      imageBlob: "",
      location: '',

      sel_recruitment_tension: "",
      recruitment_tension: [],

      sel_schedule: [],
      schedule: [],


      sel_type_of_contract: [],
      type_of_contract: [],

      sel_company_hire_engineer: "",
      company_hire_engineer: [],

      selectedCategory: "",
      categories: [],
      categoriesJP: [],
      categoriesEN: [],
      requiredTechniqueSkill: "",
      betterTechniqueSkillIfThereIs: "",
      requiredPersonality: "",
      anyRequest: "",
      technique_stack: '',

      skillEngineer: [],
      selectedSkill : [],
    };
  },
  components: {
    appSideBar: NavSidebar,
    VueNumeric,
  },
  created() {
    if (process.env.VUE_APP_RECRUIT_HIDE_FLAG === 'true') {
        this.$router.push("/global/PageNotFound");
      }
    if ("lan" in localStorage) {
      this.lan = localStorage.getItem("lan");
    }
    if (this.$route.query.id) {
      this.getRecruitmentDetails()
    }
    this.getRecruitmentTension();
    this.getSchedule();
    this.getTypeOfContract();
    this.getCompanyHireEngineer();
    this.searchSkill();
    this.getIncomeType();
  },
  mounted() {
    if (localStorage.getItem("role") == "engineer") {
      return this.$router.push("/global/PageNotFound");
    }
    EventBus.$on("language", data => {
      this.lan = data;
    });
  },
  methods: {
     getRecruitmentDetails(){
      var recruitId = this.$route.query.id;
      this.loading = true;
      var token = localStorage.getItem("token");
      axios
        .get("recruit/detail/" + recruitId+"?token=" + token, {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (res.data[0]) {
            this.$toaster.error(res.data[0]);
            this.$store.dispatch("logout");
          }
          if (res.data.result) {
            try {
              this.loading = false;
              this.title = res.data.data.recruit.subject;
              this.content = res.data.data.recruit.content;
              this.location = res.data.data.recruit.location;
              this.requiredTechniqueSkill = res.data.data.recruit.technique_skill ? res.data.data.recruit.technique_skill : '';
              this.betterTechniqueSkillIfThereIs =
                res.data.data.recruit.better_technique_skill ? res.data.data.recruit.better_technique_skill : '';
              this.requiredPersonality = res.data.data.recruit.personality ? res.data.data.recruit.personality : '';
              this.anyRequest = res.data.data.recruit.any_request ? res.data.data.recruit.any_request : '';
              this.cropImg = res.data.data.recruit.image;
              this.sel_recruitment_tension =
                res.data.data.recruit.recruitment_tension_id;
              var recruit_contract = []
                res.data.data.recruit.contract_types.forEach(element => {
                    recruit_contract.push(element.id)
                });
              this.sel_type_of_contract = recruit_contract.length > 0 ? recruit_contract  : { id: "" };

              var schedule = []
              res.data.data.recruit.freelance_types.forEach(element => {
                  schedule.push(element.id)
              });
              this.sel_schedule = schedule.length > 0 ? schedule : { id: "" };
              this.sel_company_hire_engineer = res.data.data.recruit.why_hire_engineer_id ? res.data.data.recruit.why_hire_engineer_id : '';
              this.supplement_time = res.data.data.recruit.supplement_time ? res.data.data.recruit.supplement_time : '';
              this.supplement_contract = res.data.data.recruit.supplement_contract ?  res.data.data.recruit.supplement_contract : '';
              this.en_benefits = res.data.data.recruit.en_benefits ? res.data.data.recruit.en_benefits : '';
              this.recruit_role = res.data.data.recruit.recruit_role ? res.data.data.recruit.recruit_role : '';
              this.how_to_proceed = res.data.data.recruit.how_to_proceed ? res.data.data.recruit.how_to_proceed : '';
              this.current_structure = res.data.data.recruit.current_structure ? res.data.data.recruit.current_structure : '';
              this.technique_stack = res.data.data.recruit.technique_stack ? res.data.data.recruit.technique_stack : '';
              for (let index = 0; index < res.data.data.recruit.skill_keyword.length; index++) {
                console.log(index)
                this.selectedSkill.push({
                  code: res.data.data.recruit.skill_keyword[index].check_content,
                  en_name: res.data.data.recruit.skill_keyword[index].check_content,
                  id: res.data.data.recruit.skill_keyword[index].id,
                  jp_name: res.data.data.recruit.skill_keyword[index].jp_check_content
                })

             if (res.data.data.recruit.payments.length > 0) {
               
              this.payments = [];
              for (let i = 0; i < res.data.data.recruit.payments.length; i++) {
                this.payments.push(
                  {
                    id: res.data.data.recruit.payments[i].id,
                    sel_employment_form: res.data.data.recruit.payments[i].freelance_type_id,
                    sel_time_unit: res.data.data.recruit.payments[i].income_type_id,
                    sel_lower_limit: res.data.data.recruit.payments[i].lower_limit,
                    sel_upper_limit: res.data.data.recruit.payments[i].upper_limit,
                    employmentFormFocus: false,
                    timeUnitFocus: false,
                    lowerLimitFocus: false,
                    upperLimitFocus: false,
                  }
                )
              }
             }
            }
          } catch (error) {}
        }
      })
      .catch(error => console.log(error));
    },
    getIncomeType(){
      axios
        .get("/income-types")
        .then(res => {
            this.desiar_engineer = res.data.types;
        })
        .catch(error => console.log(error));
    },
    employmentForm(index){
      this.payments[index].employmentFormFocus = false;
      this.employmentFormFocus = false;
    },
    timeUnit(index){
      this.payments[index].timeUnitFocus = false;
      this.timeUnitFocus = false;
    },
    lowerLimit(index){
      this.payments[index].lowerLimitFocus = false;
      this.lowerLimitFocus = false;
    },
    upperLimit(index){
      this.payments[index].upperLimitFocus = false;
      this.upperLimitFocus = false;
    },
    onAddJobDetail () {
      this.post
        const newJob = {
          sel_employment_form: '',
          sel_time_unit: '',
          sel_lower_limit: '',
          sel_upper_limit: '',
          employmentFormFocus: false,
          timeUnitFocus: false,
          lowerLimitFocus: false,
          upperLimitFocus: false,
        }
        this.payments.push(newJob)
      },
      onDeleteHobby (index,id) {
        if (id != undefined) {
          var formData = new FormData();
          formData.append("past_job_detail_id", id);
           axios
            .post("/delete-past-job-experience?token="+ localStorage.getItem("token"), formData)
            .then(res => {
              this.payments.splice(index, 1)
        })
        .catch(error => console.log(error));
        }else{
          this.payments.splice(index, 1)
        }
      },
    searchSkill() {
      axios
        .get("/skill-keywords?token=" + localStorage.getItem("token"))
        .then(res => {
          var skills = [];
          for (var j = 0; j < res.data.items.length; j++) {
            skills.push({
              id: res.data.items[j].id,
              code: res.data.items[j].check_content,
              en_name: res.data.items[j].check_content,
              jp_name: res.data.items[j].jp_check_content
            });
          }
          
          this.skillEngineer.push({
                skilldropdown: skills,
          });
        })
        .catch(error => console.log(error));
    },
    editProfileImageButtonClick() {
        this.$refs['myfile'].click();
    },
    readUrl(e) {
      const file = e.target.files[0];
      this.img.push(e.target.files[0].name);
      if (!file.type.includes("image/")) {
        alert("Please select an image file");
        return;
      }
      if (typeof FileReader === "function") {
        var reader = new FileReader();
        reader.onload = event => {
          this.imgSrc = event.target.result;
          this.$refs.cropper.replace(event.target.result);
          this.showModal();
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
      e.target.value = '';
    },
    showModal() {
      const elem = this.$refs.myBtnCompanyEdit;
      elem.click();
    },
    cropImage() {
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      var data = this.$refs.cropper.getCroppedCanvas({
              width: 160,
              height: 90,
              minWidth: 256,
              minHeight: 256,
              maxWidth: 4096,
              maxHeight: 4096,
              fillColor: '#fff',
              imageSmoothingEnabled: false,
              imageSmoothingQuality: 'high',
            });
      
      fetch(data.toDataURL( ))
        .then(obj => {
          return obj.blob();
        })
        .then(blob => {
          
          this.imageBlob = blob;
        });
    },
    rotate() {
      // guess what this does :)
      this.$refs.cropper.rotate(90);
    },
    b64toBlob(b64Data, contentTyper) {
      let contentType = contentTyper || "";
      let sliceSize = 512;

      let byteCharacters = atob(b64Data);
      let byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      let blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },

    convertToBlob(bsdata) {
      // Split the base64 string in data and contentType
      let block = bsdata.split(";");
      // Get the content type of the image
      let contentType = block[0].split(":")[1]; // In this case "image/gif"
      // get the real base64 content of the file
      let realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."

      // Convert it to a blob to upload
      let blob = this.b64toBlob(realData, contentType);

      return blob;
    },
    doRecuritAdd() {
      
      this.loading = true;
      var companyId = this.$route.params.cid;
      var userId = this.$route.params.uid;
      const thisVue = this;

      this.$v.$touch()
      let isPaymentFormInvalid = false;
      for (let index = 0; index < this.payments.length; index++) {
        if (this.payments[index].sel_employment_form != '' || this.payments[index].sel_time_unit != '' || this.payments[index].sel_lower_limit != 0) {
          if (this.payments[index].sel_employment_form == '' ) {
            this.payments[index].employmentFormFocus = true; 
            this.employmentFormFocus = true;
            isPaymentFormInvalid = true;
          }
          if (this.payments[index].sel_time_unit == '' ) {
            this.payments[index].timeUnitFocus = true; 
            isPaymentFormInvalid = true;
          }
          if (this.payments[index].sel_lower_limit == 0 ) {
            this.payments[index].lowerLimitFocus = true;
            this.lowerLimitFocus = true;
            isPaymentFormInvalid = true; 
          }
        }
      }

      if (this.$v.$invalid || isPaymentFormInvalid) {
        this.titleFocus = true;
        this.contentFocus = true;
        this.locationFocus = true;
        this.tensionFocus = true;
        this.skillFocus = true;
        this.scheduleFocus = true;
        this.contractFocus = true;
        this.selectedSkillFocus = true;
        this.loading = false;
        setTimeout(() => {
          $('html, body').animate({scrollTop:$('.invalid').offset().top-50}, 'slow');
        },1);
        return
      } 
      else {
        var formData = new FormData();
        
        formData.append("subject", this.title);
        formData.append("content", this.content);
        formData.append("recruitment_tension", this.sel_recruitment_tension);
        formData.append("why_hire_engineer", this.sel_company_hire_engineer);
        formData.append("technique_skill", this.requiredTechniqueSkill);
        formData.append("better_technique_skill",this.betterTechniqueSkillIfThereIs);
        formData.append("personality", this.requiredPersonality);
        formData.append("any_request", this.anyRequest);
        formData.append("location", this.location);
        formData.append("supplement_time", this.supplement_time);
        formData.append("supplement_contract", this.supplement_contract);
        formData.append("en_benefits", this.en_benefits);
        formData.append("recruit_role", this.recruit_role);
        formData.append("how_to_proceed", this.how_to_proceed);
        formData.append("current_structure", this.current_structure);
        formData.append("technique_stack", this.technique_stack);

        for (var i = 0; i < this.payments.length; i++) {
          if (this.payments[i].sel_employment_form != '' || this.payments[i].sel_time_unit != '' || this.payments[i].sel_lower_limit != '' || this.payments[i].sel_upper_limit != '' ) {
              formData.append("payments[" + i + "][freelance_type_id]", this.payments[i].sel_employment_form)
              formData.append("payments[" + i + "][income_type_id]", this.payments[i].sel_time_unit)
              formData.append("payments[" + i + "][lower_limit]", this.payments[i].sel_lower_limit)
              if(this.payments[i].sel_lower_limit > this.payments[i].sel_upper_limit && this.payments[i].sel_upper_limit != 0){
                this.$toaster.error(i+1+ '. ' + this.$t('payment_upper_limit_validation'));
                setTimeout(() => {
                  $('html, body').animate({scrollTop:$('.payment').offset().top-80}, 'slow');
                },1);
                this.loading = false;
                return;
              }
              else{
                formData.append("payments[" + i + "][upper_limit]", this.payments[i].sel_upper_limit)
              }

          } 
        }

        if (this.selectedSkill.length > 0)
        {
          let selectedSkills = this.selectedSkill
          .filter(obj => {
            return  obj.id;
          })
          .map(item => {
            return item.id;
          });
          formData.append("skill_keyword", selectedSkills);
        }
        if (this.imageBlob != "") {
          formData.append("image", this.imageBlob, "temp.png");
        }
        for (var i = 0; i < this.sel_schedule.length; i++) {
          formData.append("freelance_type[" + i + "]", this.sel_schedule[i])
        }
        for (var i = 0; i < this.sel_type_of_contract.length; i++) {
          formData.append("contract_type[" + i + "]", this.sel_type_of_contract[i])
        }
        axios
            .post(
              "/recruit/create?token=" + localStorage.getItem("token"),
              formData,
              {
                headers: { "X-localization": localStorage.getItem("lan") }
              }
            )
            .then(res => {
              if (!res.data.result) {
                if (res.data[0]) {
                  this.$toaster.error(res.data[0]);
                  this.$store.dispatch("logout");
                }
                if (res.data.errors) {
                    for (var i = 0; i < res.data.errors.length; i++) {
                      if (res.data.errors[i].field === "payments."+ (i+1) +".freelance_type_id") {
                          this.$toaster.error(res.data.errors[i].message);
                          $('html, body').animate({scrollTop:1550}, 'slow');
                        } 
                      else if (res.data.errors[i].field === "payments."+ (i+1) +".income_type_id") {
                          this.$toaster.error(res.data.errors[i].message);
                          $('html, body').animate({scrollTop:1550}, 'slow');
                        } 
                        else{
                            this.$toaster.error(res.data.errors[i].message);
                        }
                    }
                }
                this.loading = false;
              } else {
                this.title = "";
                this.content = "";
                this.sel_recruitment_tension = "";
                this.sel_type_of_contract = "";
                this.sel_schedule = "";
                this.sel_company_hire_engineer = "";
                this.selectedCategory = "";
                this.requiredTechniqueSkill = "";
                this.betterTechniqueSkillIfThereIs = "";
                this.requiredPersonality = "";
                this.anyRequest = "";
                this.technique_stack = "";
                this.loading = false;
                this.$toaster.success(thisVue.$t("success_recruit_add"));
                this.$router.push({
                  name: "companyRecuritList",
                  params: { cid: companyId, uid: userId },
                  query: { page: 1 }
                });
              }
            })
            .catch(() => {
              this.$toaster.error(vm.$t("err_network"));
            });
      }
    },
    getRecruitmentTension() {
      axios
        .get("/recruitment-tension")
        .then(res => {
          this.recruitment_tension = res.data.tensions;
        })
        .catch(error => console.log(error));
    },
    getSchedule() {
      axios
        .get("/freelance-types")
        .then(res => {
          this.schedule = res.data.types;
        })
        .catch(error => console.log(error));
    },
    getTypeOfContract() {
      axios
        .get("/contract-types")
        .then(res => {
          this.type_of_contract = res.data.types;
        })
        .catch(error => console.log(error));
    },
    getCompanyHireEngineer() {
      axios
        .get("/why-hire-engineers")
        .then(res => {
          this.company_hire_engineer = res.data.reasons;
        })
        .catch(error => console.log(error));
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.yen{
  display: contents;
}
.yen-child{
  margin-top: 1rem;
}
.clickcbtn {
  border-radius: 20px;
  padding: 7px 14px;
  box-shadow: 0 1px 4px 0 rgba(40, 60, 80, 0.4);
  float: right;
  margin-top: 10px
}
.skillTag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #3d7dd8 !important;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  min-height: 22px !important;
}
.multiselect__tags-wrap .multiselect__tag {
  background: #3d7dd8 !important;
}
.input.invalid label {
    color: red !important;
  }
  .input.invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
  }
  .input.invalid select{
    border: 1px solid red;
    background-color: #ffc9aa;
  }
  .input.invalid textarea{
    border: 1px solid red;
    background-color: #ffc9aa;
  }
  .errorClass.invalid label{
    color: red
  }
  .errorClass.invalid .material-control-description{
    color: black
  }
  .errorClass.invalid .listError{
    border: 1px solid red !important;
    background-color: #ffc9aa !important;
  }

.custom-control.material-checkbox {
    --color: #3d7dd8;
  }

  .custom-control.material-checkbox .material-control-input {
    display: none;
  }

  .custom-control.material-checkbox
  .material-control-input:checked
  ~ .material-control-indicator {
    border-color: var(--color);
    -webkit-transform: rotateZ(45deg) translate(1px, -5px);
    transform: rotateZ(45deg) translate(1px, -5px);
    width: 10px;
    border-top: 0px solid #fff;
    border-left: 0px solid #fff;
  }

  .custom-control.material-checkbox .material-control-indicator {
    display: inline-block;
    position: absolute;
    top: 4px;
    left: 0;
    width: 16px;
    height: 16px;
    border: 2px solid #aaa;
    transition: 0.3s;
  }

.pman {
  margin-top: 70px;
}

.slide_options {
  background-color: #f8fafa;
  border-radius: 30px;
  margin: 10px 0px;
  margin-top: 44px;
  padding: 5px 0px;
}

.slide_item {
  text-align: center;
  padding: 18px;
  cursor: pointer;
}

.spressed {
  text-align: center;
  padding: 18px;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
}

.slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #b4bec8;
}

.spressed .slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #3d7dd8;
}

.pview {
  margin-bottom: 80px;
}

.company {
  width: 80%;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.cs_summary {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  margin-top: 21px;
}

.pvlabel {
  margin-left: 20px;
}

.pv_btnpanel {
  padding: 0px 10%;
}

.updatebtn {
  width: 100%;
  height: 56px;
}

.pv_showchart {
  background-color: #f8f8fa;
  margin-top: 16px;
}

.eview {
  padding: 30px 15px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 30px;
  max-width: 200px;
  height: 100px;
}

.statustitle {
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 34px;
  margin-bottom: 0.1rem;
}

.statusnum {
  position: absolute;
  font-weight: bold;
  font-size: 1.5rem;
}

.caltxt {
  margin-top: 45px;
}

.calpanel {
  text-align: right;
}

.camera {
  box-shadow: 0 2px 4px 0 rgba(40, 60, 80, 0.12);
  background-color: #ffffff;
  border: solid 1px #c8d2dc;
  border-radius: 100px;
  padding: 8px 9px;
  position: relative;
  top: 60px;
  right: 45px;
  cursor: pointer;
}

.camera:hover {
  background-color: #3d7dd8;
}

.camera:hover .fa-camera {
  color: white;
}

.camera .fa-camera {
  font-size: 20px;
  color: #3d7dd8;
}

.peditlabel {
  font-size: 1rem;
  font-weight: 500;
  margin-left: 20px;
  margin-top: 20px;
}

.peditinput {
  width: 100%;
  height: 44px;
  padding: 0px 16px;
  margin-left: 20px;
}

.pedittextarea {
  width: 100%;
  height: 188px;
  padding: 16px;
  margin-left: 20px;
}

.peselectboxs {
  float: left;
  margin-left: 20px;
}

.selectdiv select {
  height: 50px !important;
}

.peradioboxs {
  text-align: center;
  min-width: 128px;
  height: 50px;
  float: left;
  background-color: #ffffff;
  border: 1px solid #b4bec8;
  color: #b4bec8;
  margin-left: 20px;
  margin-top: 5px;
  padding-top: 10px;
  border-radius: 4px;
  cursor: pointer;
}

.manradio:hover,
.mchosen {
  border: 1px solid #3d7dd8;
  color: #3d7dd8;
}

.womenradio:hover,
.wchosen {
  border: 1px solid #f878c8;
  color: #f878c8;
}
.error-block {
  color: #ff0000;
  margin-left: -7px; 
}

.peradiotxt {
  font-size: 0.875rem;
  font-weight: bold;
}

.linput {
  width: 423px;
}

.help-block {
  margin-left: 20px;
  margin-top: 10px;
}

.form-group {
  margin-bottom: 0px;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  top: 105px;
  right: 30px;
  opacity: 0;
}

.pheaderpanel {
  margin: 0px 20px;
  margin-top: 30px;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.businesspanel {
  margin-top: 50px;
}

.futhergraytxt {
  font-size: 1rem;
  font-weight: 500;
  opacity: 0.64;
}

.pfpanel {
  height: 50px;
}

.blog1 {
  width: 100%;
}

@media screen and (max-width: 1200px) {
  .camera {
    top: 80px;
    right: 20px;
  }

  .upload-btn-wrapper input[type="file"] {
    top: 80px;
    right: 20px;
  }

  .businesspanel {
    margin-top: 20px;
  }
}

@media screen and (max-width: 992px) {
  .camera {
    top: 50px;
    right: 20px;
  }

  .upload-btn-wrapper input[type="file"] {
    top: 50px;
    right: 20px;
  }

  .linput {
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .pman {
    margin-top: 0px;
  }

  .company {
    width: 50%;
  }

  .page_title {
    margin-top: 40px;
  }

  .pvlabel {
    margin-left: 0px;
  }

  .calpanel {
    text-align: center;
  }

  .camera {
    top: 80%;
    right: 20%;
  }

  .peditlabel {
    margin-left: 0px;
  }

  .peditinput {
    margin-left: 0px;
  }

  .pedittextarea {
    margin-left: 0px;
  }

  .peselectboxs {
    width: 100%;
    margin-left: 0px;
  }

  .peradioboxs {
    width: 100%;
    margin-left: 0px;
  }

  .help-block {
    margin-left: 0px;
    margin-top: 10px;
  }

  .upload-btn-wrapper input[type="file"] {
    top: 80%;
    right: 20%;
  }

  .pheaderpanel {
    margin: 0px;
    margin-top: 30px;
  }
}

@media screen and (max-width: 575.98px) {
  .pman {
    width: 100%;
  }
}
</style>
